import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useNotification } from "~/Hooks/useNotification";
import { magpCMSApi, post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { useDocumentDetails } from "../../../ApprovalManagement/Drilldown.Hooks";
import { useSourcing } from "../Manual.hook";
import { fields } from "../manualConstants";
import { SourcingProcessFlowChart } from "./SourcingProcessFlowChart";

export const Sourcing: React.FC = (): JSX.Element => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [tabsData, setTabsData] = useState<any[]>([]);
  const [subTabsData, setSubTabsData] = useState<any[]>([]);
  const [listId, setListId] = useState("");
  const [toggleId, setToggleId] = useState("");
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  const {
    data: sourcingData,
    isLoading: isLoadingSourcing,
    refetch: refetchData,
  } = useSourcing(listId || "30", toggleId || "133");
  const {
    data: sourcingDataById,
    isLoading: isLoadingSourcingById,
    refetch: refetchDataById,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (approveId) {
      return;
    }

    const thirdChildActiveTab = query.get("thirdChildActiveTab");

    if (query.get("activeTab") === "sourcing" && query.get("subActiveTab") === "tenderManagement") {
      navigate(
        `/dedicated/magp/manual?activeTab=sourcing&subActiveTab=tenderManagement&thirdChildActiveTab=${
          thirdChildActiveTab ?? "tenderManagementOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "tenderManagementOverview") {
        setListId("30");
        setToggleId("133");
      } else if (thirdChildActiveTab === "tenderManagementPolicies") {
        setListId("30");
        setToggleId("134");
      } else if (thirdChildActiveTab === "tenderManagementProcessFlowChart") {
        setListId("30");
        setToggleId("135");
      } else {
        setListId("30");
        setToggleId("133");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "sourcing" && query.get("subActiveTab") === "tenderAdministration") {
      navigate(
        `/dedicated/magp/manual?activeTab=sourcing&subActiveTab=tenderAdministration&thirdChildActiveTab=${
          thirdChildActiveTab ?? "tenderAdministrationOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "tenderAdministrationOverview") {
        setListId("31");
        setToggleId("150");
      } else if (thirdChildActiveTab === "tenderAdministrationPolicies") {
        setListId("31");
        setToggleId("151");
      } else if (thirdChildActiveTab === "tenderAdministrationProcessFlowChartaboveRM5000000") {
        setListId("31");
        setToggleId("152");
      } else if (thirdChildActiveTab === "tenderAdministrationProcessFlowChartbelowRM5000000") {
        setListId("31");
        setToggleId("226");
      } else {
        setListId("31");
        setToggleId("150");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "sourcing" && query.get("subActiveTab") === "tenderEvaluation") {
      navigate(
        `/dedicated/magp/manual?activeTab=sourcing&subActiveTab=tenderEvaluation&thirdChildActiveTab=${
          thirdChildActiveTab ?? "tenderEvaluationOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "tenderEvaluationOverview") {
        setListId("32");
        setToggleId("153");
      } else if (thirdChildActiveTab === "tenderEvaluationPolicies") {
        setListId("32");
        setToggleId("154");
      } else if (thirdChildActiveTab === "tenderEvaluationProcessFlowChart") {
        setListId("32");
        setToggleId("155");
      } else {
        setListId("32");
        setToggleId("153");
      }
      // refetchData();
    }
    if (query.get("activeTab") === "sourcing" && query.get("subActiveTab") === "abortofTender") {
      navigate(
        `/dedicated/magp/manual?activeTab=sourcing&subActiveTab=abortofTender&thirdChildActiveTab=${
          thirdChildActiveTab ?? "abortofTenderOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "abortofTenderOverview") {
        setListId("33");
        setToggleId("156");
      } else if (thirdChildActiveTab === "abortofTenderPolicies") {
        setListId("33");
        setToggleId("157");
      } else if (thirdChildActiveTab === "abortofTenderProcessFlowChart") {
        setListId("33");
        setToggleId("158");
      } else {
        setListId("33");
        setToggleId("156");
      }
      // refetchData();
    }

    if (query.get("activeTab") === "sourcing" && query.get("subActiveTab") === "clarificationNegotiationpriortoAward") {
      navigate(
        `/dedicated/magp/manual?activeTab=sourcing&subActiveTab=clarificationNegotiationpriortoAward&thirdChildActiveTab=${
          thirdChildActiveTab ?? "clarificationNegotiationpriortoAwardOverview"
        }`,
        {
          replace: true,
        }
      );
      if (thirdChildActiveTab === "clarificationNegotiationpriortoAwardOverview") {
        setListId("34");
        setToggleId("159");
      } else if (thirdChildActiveTab === "clarificationNegotiationpriortoAwardPolicies") {
        setListId("34");
        setToggleId("160");
      } else if (thirdChildActiveTab === "clarificationNegotiationpriortoAwardProcessFlowChartNegotiation") {
        setListId("34");
        setToggleId("161");
      } else if (
        thirdChildActiveTab === "clarificationNegotiationpriortoAwardProcessFlowChartClarificationPriortoAward"
      ) {
        setListId("34");
        setToggleId("227");
      } else {
        setListId("34");
        setToggleId("159");
      }
      // refetchData();
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);

  useEffect(() => {
    refetchData();
  }, []);
  useEffect(() => {
    if (listId && toggleId) {
      refetchData();
    }
  }, [listId, toggleId]);
  useEffect(() => {
    if (query?.get("id")) {
      refetchDataById();
    }
  }, [query?.get("id")]);

  const SourcingFormConfig: FormConfig = {
    initialValues: {
      title: sourcingDataById?.payload
        ? decodeHTML(sourcingDataById?.payload?.title)
        : decodeHTML(sourcingData?.[0]?.title),
      field_sourcing_desc_en: sourcingDataById?.payload
        ? decodeHTML(sourcingDataById?.payload?.field_sourcing_desc_en?.value)
        : decodeHTML(sourcingData?.[0]?.field_sourcing_desc_en),
      field_sourcing_desc_ms: sourcingDataById?.payload
        ? decodeHTML(sourcingDataById?.payload?.field_sourcing_desc_ms?.value)
        : decodeHTML(sourcingData?.[0]?.field_sourcing_desc_ms),
      field_sourcing_desc_zh: sourcingDataById?.payload
        ? decodeHTML(sourcingDataById?.payload?.field_sourcing_desc_zh?.value)
        : decodeHTML(sourcingData?.[0]?.field_sourcing_desc_zh),
      field_sourcing_video_url: sourcingDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "video_url.mp4",
              status: "done",
              url: sourcingDataById?.payload?.field_sourcing_video_url,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "video_url.mp4",
              status: "done",
              url: sourcingData?.[0]?.field_sourcing_video_url,
            },
          ]),
      field_sourcing_details_web_image: sourcingDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_procure_details_web_image.png",
              status: "done",
              url: sourcingDataById?.payload?.field_sourcing_details_web_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_procure_details_web_image.png",
              status: "done",
              url: sourcingData?.[0]?.field_sourcing_details_web_image,
            },
          ]),
      field_sourcing_web_flowchart_img: sourcingDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_procure_details_web_image.png",
              status: "done",
              url: sourcingDataById?.payload?.field_sourcing_web_flowchart_img,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_procure_details_web_image.png",
              status: "done",
              url: sourcingData?.[0]?.field_sourcing_web_flowchart_img,
            },
          ]),
    },
    fields: fields.sourcing,
  };

  useEffect(() => {
    const fetchTabsData = async () => {
      try {
        const response = await magpCMSApi.get(`/api/sourcing-list/all-fields`);
        const tabData = response.data.map((tab: any) => {
          const listId = tab?.id;
          const label = tab?.field_sourcing_process_name_en.replace(/^\d+\.\d+\s*/, "");
          let key = label
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .replace(/\s+/g, "")
            .replace(/\s[a-z]/g, (match: any) => match.trim().toUpperCase());
          key = key.charAt(0).toLowerCase() + key.slice(1);
          return { listId, label, key };
        });

        // tabData.push({
        //   listId: "",
        //   label: "Process Flow Chart",
        //   key: "sourcingProcessFlowChart"
        // });

        setTabsData(tabData);
      } catch (error) {}
    };

    fetchTabsData();

    const subActiveTab = query.get("subActiveTab") ?? "tenderManagement";

    const listId =
      subActiveTab === "tenderManagement"
        ? "30"
        : subActiveTab === "tenderAdministration"
          ? "31"
          : subActiveTab === "tenderEvaluation"
            ? "32"
            : subActiveTab === "abortofTender"
              ? "33"
              : "34";

    fetchSubTabsData(subActiveTab, listId);
  }, []);

  useEffect(() => {
    if (sourcingDataById !== undefined && !isLoadingSourcing) {
      const urlParams = new URLSearchParams(window.location.search);
      const subActiveTab = urlParams.get("subActiveTab") || "businessCase";
      const selectedTab = tabsData.find((tab) => tab.key === subActiveTab);

      if (selectedTab !== undefined) {
        fetchSubTabsData(subActiveTab, selectedTab.listId);
      }
    }
  }, [sourcingDataById, tabsData, isLoadingSourcing]);

  const fetchSubTabsData = async (activeKey: string, listId: string) => {
    if (!listId) {
      return;
    }
    try {
      const response = await magpCMSApi.get(`/api/sourcing-topbar-toggle/all-fields?listId=${listId}`);
      const subTabData = response.data.map((subTab: any) => {
        const formattedName = subTab.name
          .replace(/\s+/g, "")
          .replace(/(\s[a-z])/g, (match: string) => match.trim().toUpperCase())
          .replace(/[^a-zA-Z0-9]/g, "");

        return {
          toggleId: subTab.id,
          listId: subTab.field_sourcing_list_reference,
          label: subTab.name,
          key: `${activeKey}${formattedName}`,
        };
      });
      2;

      setSubTabsData(subTabData);
    } catch (error) {}
  };

  const handleTabChange = (activeKey: string) => {
    const selectedTab = tabsData.find((tab) => tab.key === activeKey);

    if (selectedTab) {
      fetchSubTabsData(activeKey, selectedTab.listId);
      navigate(`${window.location.pathname}?activeTab=sourcing&subActiveTab=${activeKey}`);
    }
  };

  const handleSubTabChange = (listId: string, activeKey: string) => {
    setListId(listId);
    const subTab = subTabsData.find((subTab) => subTab.key === activeKey);
    if (subTab) {
      setToggleId(subTab.toggleId);
    }
    navigate(
      `${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${query?.get(
        "subActiveTab"
      )}&thirdChildActiveTab=${activeKey}`
    );
  };
  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
      "field_sourcing_details_web_image",
      "field_sourcing_video_url",
      "field_sourcing_web_flowchart_img",
    ];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field && field[0]) {
          if (field[0].originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "MAGP");
            const res: any = await post("management/upload-file", formData);

            if (res) {
              data[key] = res.response.data;
            }
          } else {
            data[key] = data[key][0].url;
          }
        }
      } catch (error) {}
    }

    let descKeys: any = ["field_sourcing_desc_en", "field_sourcing_desc_ms", "field_sourcing_desc_zh"];
    for (const key of descKeys) {
      try {
        data[key] = {
          value: data[key] || "",
          format: "full_html",
        };
      } catch (error) {}
    }
    const payload = {
      action: action,
      method: method,
      module: "Manual",
      subModule: `${query?.get("activeTab")}_${query?.get("subActiveTab")}_${query?.get("thirdChildActiveTab")}`,
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        // id: data?.id,
        field_sourcing_list_parent_id: sourcingData?.[0]?.field_sourcing_list_parent_id || listId,
        field_sourcing_toggle_reference: sourcingData?.[0]?.field_sourcing_toggle_reference || toggleId,
        ...data,
        published: true,
        // createdAt: "2024-07-16T07:44:25",
        // updatedAt: "2024-07-16T07:44:30",
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  const superSubChildItems = tabsData.map((tab: any) => {
    return {
      label: tab.label,
      key: tab.key,
      children: (
        <Tabs
          activeKey={query?.get("thirdChildActiveTab") || ""}
          items={subTabsData.map((subTab: any) => {
            const processFlowChartTab: any[] = [
              "clarificationNegotiationpriortoAwardProcessFlowChartClarificationPriortoAward",
              "clarificationNegotiationpriortoAwardProcessFlowChartNegotiation",
              "abortofTenderProcessFlowChart",
              "tenderEvaluationProcessFlowChart",
              "tenderAdministrationProcessFlowChartbelowRM5000000",
              "tenderAdministrationProcessFlowChartaboveRM5000000",
              "tenderManagementProcessFlowChart",
              "sourcingProcessFlowChart",
            ];
            const isProcessFlowChartTab = processFlowChartTab.includes(subTab.key);

            return {
              label: subTab.label,
              key: subTab.key,
              children: isProcessFlowChartTab ? (
                <>
                  <DynamicForm
                    config={SourcingFormConfig}
                    onSubmit={(data, buttonValue, reviewNotes) =>
                      onSubmit(
                        data,
                        `${magpHost}/api/sourcing-details/${sourcingData?.[0]?.id}`,
                        "UPDATE",
                        "PATCH",
                        buttonValue == "save" ? "DRAFT" : "PENDING",
                        reviewNotes
                      )
                    }
                  />
                  <SourcingProcessFlowChart
                    listId={listId}
                    toggleId={toggleId}
                  />
                </>
              ) : (
                <DynamicForm
                  config={SourcingFormConfig}
                  onSubmit={(data, buttonValue, reviewNotes) =>
                    onSubmit(
                      data,
                      `${magpHost}/api/sourcing-details/${sourcingData?.[0]?.id}`,
                      "UPDATE",
                      "PATCH",
                      buttonValue == "save" ? "DRAFT" : "PENDING",
                      reviewNotes
                    )
                  }
                />
              ),
            };
          })}
          onChange={(activeKey: any) => handleSubTabChange(tab.listId, activeKey)}
        />
      ),
    };
  });

  if (isLoadingSourcing || isLoadingSourcingById) {
    return <Loader />;
  }

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={superSubChildItems}
      onChange={handleTabChange}
    />
  );
};
